// @copyright  2006-2023 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: ':id/batch/:batchId/new-payroll-payment',
        component: () =>
            import(/* webpackChunkName: "human-resource.payroll-batch-payments" */ '@/pages/[organisation]/hr/payroll-batch-payments/payroll-batch-payment/new.vue'),
        name: 'human-resource.payroll-batch-payments.create-payroll-batch-payment',
        meta: {
            loginRequired: true,
            permission: 'access.payroll.payroll-batch-payment.create-payroll-batch-payment',
        },
    },
    {
        path: ':id/batch/:batchId/payroll-batch-payments',
        component: () =>
            import(/* webpackChunkName: "human-resource.payroll-batch-payments" */ '@/pages/[organisation]/hr/payroll-batch-payments/payroll-batch-payments.vue'),
        name: 'human-resource.payroll-batch-payments.search-payroll-batch-payments',
        meta: {
            loginRequired: true,
            permission: 'access.payroll.payroll-batch-payment.view-payroll-batch-payments',
        },
    },
    {
        path: ':id/batch/:batchId/payroll-batch-payments/:paymentId/redo',
        component: () =>
            import(/* webpackChunkName: "human-resource.payroll-batch-payments" */ '@/pages/[organisation]/hr/payroll-batch-payments/redo-payroll-batch-payment.vue'),
        name: 'human-resource.payroll-batch-payments.redo-payroll-batch-payment',
        meta: {
            loginRequired: true,
            permission: 'access.payroll.payroll-batch-payment.create-payroll-batch-payment',
        },
    },
];
